export default __webpack_public_path__ + "static/media/purple_loved.2f03b534.webp";